import React, { useState } from "react";
import { Typography, Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// const styles = {
//   alertBox: {
//     backgroundColor: "#FDEBE6",
//     color: "#333",
//     padding: "10px 15px",
//     borderRadius: "5px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "left",
//     border: "1px solid #ffcccb",
//     fontFamily: "Arial, sans-serif",
//     maxWidth: "400px",
//   },
//   closeBtn: {
//     cursor: "pointer",
//     fontSize: "18px",
//     fontWeight: "bold",
//     border: "none",
//     background: "none",
//     color: "#666",
//   },
// };
// const CommunicationStatus = ({onClose,mode, show} :
//   {
//     onClose:any,
//     mode:any, 
//     show:any
//   }) => {

// const [visible, setVisible] = useState(false);
  
//  const hide =(v)=> {
//   onClose(v);
//  }
//   return (
    
//         <div style={styles.alertBox}>
//         <span>Failed to log to Clarra. Please try again.</span>
//         <button style={styles.closeBtn} onClick={() => hide(false)}>
//           &times;
//         </button>
//       </div>
//   );
// };
// export default CommunicationStatus;


const styles = {
  alertBox: {
    backgroundColor: "#FDEBE6",
    color: "#333",
    padding: "10px 15px",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #ffcccb",
    fontFamily: "Arial, sans-serif",
    maxWidth: "400px",
  },
  closeBtn: {
    cursor: "pointer",
    fontSize: "18px",
    fontWeight: "bold",
    border: "none",
    background: "none",
    color: "#666",
    marginLeft: "8px",
  },
  viewMore: {
    color: "#0078d4",
    cursor: "pointer",
    marginLeft: "6px",
    fontSize: "12px",
    textDecoration: "underline",
  },
};

type CommunicationStatusProps = {
  onClose: (v: boolean) => void;
  mode?: string;
  show: boolean;
  message?: string;
};

const CommunicationStatus: React.FC<CommunicationStatusProps> = ({
  onClose,
  mode,
  show,
  message = "Failed to log to Clarra. Please try again.",
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  if (!show) return null;

  const truncated =
    message.length > 50 ? message.substring(0, 30) + "..." : message;

  return (
    <>
      {/* Main Alert Box */}
      <div style={styles.alertBox}>
        <Typography variant="body2">
          {truncated}
          {message.length > 50 && (
            <span style={styles.viewMore} onClick={() => setOpenDialog(true)}>
              Show
            </span>
          )}
        </Typography>
        <button style={styles.closeBtn} onClick={() => onClose(false)}>
          &times;
        </button>
      </div>

      {/* Popup Dialog for full message */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Details</DialogTitle>
        <DialogContent>
          <Typography variant="body1">{message}</Typography>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CommunicationStatus;
